import { render, staticRenderFns } from "./object-list-input.vue?vue&type=template&id=5b72a9d1&scoped=true&"
import script from "./object-list-input.vue?vue&type=script&lang=js&"
export * from "./object-list-input.vue?vue&type=script&lang=js&"
import style0 from "./object-list-input.vue?vue&type=style&index=0&id=5b72a9d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b72a9d1",
  null
  
)

export default component.exports